import { compareSgsProductionCalendarStationOrder } from "./sgsProductionCalendarStationOrder";

export type BatchDetailsSerialsSortKey =
  | "device_label"
  | "station"
  | "imei"
  | "portal_org"
  | "portal_group"
  | "portal_match"
  | "finished_sku"
  | "box_label";

export type BatchDetailsSerialsSortDir = "asc" | "desc";

export interface BatchDetailsSerialsSortRow {
  serial_fci_id: number;
  device_label_serial: string | null;
  station_id: number | null;
  imei: string | null;
  wireless_portal_org_name: string | null;
  wireless_portal_group_names: string | null;
  finished_sku: string | null;
  box_serial: string | null;
}

export interface BatchDetailsSerialsPortalAlignment {
  aligned: boolean;
}

function compareNullableText(left: string | null, right: string | null): number {
  return (left ?? "").localeCompare(right ?? "", undefined, { numeric: true, sensitivity: "base" });
}

function portalMatchRank(
  row: BatchDetailsSerialsSortRow,
  alignmentBySerialFciId: Record<string, BatchDetailsSerialsPortalAlignment | undefined>,
): number {
  if ((row.imei ?? "").trim() === "") return 3;
  const alignment = alignmentBySerialFciId[String(row.serial_fci_id)];
  if (alignment == null) return 2;
  return alignment.aligned ? 0 : 1;
}

export function compareBatchDetailsSerialRows(
  left: BatchDetailsSerialsSortRow,
  right: BatchDetailsSerialsSortRow,
  sortKey: BatchDetailsSerialsSortKey,
  sortDir: BatchDetailsSerialsSortDir,
  alignmentBySerialFciId: Record<string, BatchDetailsSerialsPortalAlignment | undefined>,
): number {
  let cmp = 0;
  switch (sortKey) {
    case "device_label":
      cmp = compareNullableText(left.device_label_serial, right.device_label_serial);
      break;
    case "station":
      cmp = compareSgsProductionCalendarStationOrder(
        { stationId: left.station_id, isTerminal: false },
        { stationId: right.station_id, isTerminal: false },
      );
      break;
    case "imei":
      cmp = compareNullableText(left.imei, right.imei);
      break;
    case "portal_org":
      cmp = compareNullableText(left.wireless_portal_org_name, right.wireless_portal_org_name);
      break;
    case "portal_group":
      cmp = compareNullableText(left.wireless_portal_group_names, right.wireless_portal_group_names);
      break;
    case "portal_match":
      cmp =
        portalMatchRank(left, alignmentBySerialFciId) -
        portalMatchRank(right, alignmentBySerialFciId);
      break;
    case "finished_sku":
      cmp = compareNullableText(left.finished_sku, right.finished_sku);
      break;
    case "box_label":
      cmp = compareNullableText(left.box_serial, right.box_serial);
      break;
  }
  if (cmp === 0) {
    cmp = compareNullableText(left.device_label_serial, right.device_label_serial);
  }
  if (cmp === 0) {
    cmp = left.serial_fci_id - right.serial_fci_id;
  }
  return sortDir === "asc" ? cmp : -cmp;
}
